(() => {
  const key = 'filter.v.availability';
  const isCollection = (url) => /\/collections\/[^/]+/.test(url.pathname) && !url.pathname.includes('/products/');
  const normalize = (value) => {
    const params = new URLSearchParams(value);
    params.delete(key);
    params.set(key, '1');
    return params.toString();
  };
  window.GolzarListingFilter = { normalize };
  const current = new URL(window.location.href);
  if (isCollection(current) && (current.searchParams.getAll(key).length !== 1 || current.searchParams.get(key) !== '1')) {
    current.searchParams.delete('page');
    current.search = normalize(current.search);
    window.location.replace(current.href);
    return;
  }
  const prepareLink = (event) => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || anchor.hasAttribute('download')) return;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin === window.location.origin && isCollection(url)) {
      url.search = normalize(url.search);
      anchor.href = url.href;
    }
  };
  document.addEventListener('click', prepareLink, true);
  document.addEventListener('auxclick', prepareLink, true);
})();
